import React from "react";

import "../styles.scss";
import "../scripts";

import {
  secondaryBlock,
  SecondaryBlockSize,
  KameleonElement,
  SecondaryBlockConfig,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box } from "theme-ui";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { ContactType, layoutOptions } from "./types/prop-types";

/** Contact Secondary */
const blockConfig: SecondaryBlockConfig = {
  blockSize: SecondaryBlockSize.Medium,
};

export const Contact = secondaryBlock<ContactType>(
  blockConfig,
  ({
    icon,
    text1,
    text2,
    link,
    linkText,
    primaryButtonText,
    primaryButtonLink,
    secondaryButtonText,
    secondaryButtonLink,
    tertiaryButtonText,
    tertiaryButtonLink,
    layoutProps,
  }: ContactType) => (
    <Box
      sx={{ marginTop: "1.5rem" }}
      className="secondary-contact-medium-v1 margin-section-medium direction-vertical"
    >
      <Variants.BoxGrey
        hasBg={layoutProps.showItemBackground}
        className="quote-medium padding-xsmall align-left"
      >
        <Box className="top margin-right margin-xsmall align-top">
          <Variants.IconTiny
            hasBg={layoutProps.showIconBackground}
            icon={icon}
          />
        </Box>
        <Box className="testimonial25_client-info">
          <Variants.ParagraphDefault>{text1}</Variants.ParagraphDefault>
          <Variants.ParagraphDefault>
            <Variants.LinkUnderline
              as="strong"
              sx={{ fontWeight: "bold" }}
              href={link}
            >
              {linkText}
            </Variants.LinkUnderline>
          </Variants.ParagraphDefault>
          <Variants.ParagraphDefault>{text2}</Variants.ParagraphDefault>
        </Box>
      </Variants.BoxGrey>
      <Variants.ButtonGroup
        className="margin-top margin-custom1"
        primaryButtonText={primaryButtonText}
        primaryButtonLink={primaryButtonLink}
        secondaryButtonText={secondaryButtonText}
        secondaryButtonLink={secondaryButtonLink}
        tertiaryButtonText={tertiaryButtonText}
        tertiaryButtonLink={tertiaryButtonLink}
      />
    </Box>
  )
);

Contact.defaultProps = getDefaultProps<ContactType>(defaults);

export const Element: KameleonElement = {
  component: Contact,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
